import React from 'react'

import { Typography } from "@mui/material"


export default function priceChangeDiffColumn() {

	return {
		name: 'priceDiff',
		label: 'Diff',
		options: {
			customBodyRowRenderLite: value => <Typography sx={{ textAlign: "center" }}>{value}%</Typography>
		}
	}
}